import React, { useState, useEffect } from "react";
import { Activity, Clock, Building2, User, Info, Search, Filter } from "lucide-react";
import api from "../api/axiosInstance";

const ActivityMonitor = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("");

    useEffect(() => {
        api.get("get_admin_logs.php").then(res => {
            setLogs(res.data.logs || []);
            setLoading(false);
        });
    }, []);

    const filteredLogs = logs.filter(log =>
        log.company_name.toLowerCase().includes(filter.toLowerCase()) ||
        log.action.toLowerCase().includes(filter.toLowerCase())
    );

    if (loading) return <div className="p-20 text-center animate-pulse font-black text-slate-300">RETRIEVING SYSTEM LOGS...</div>;

    return (
        <div className="p-8 space-y-8 bg-slate-50 min-h-screen">
            <div className="flex justify-between items-end">
                <div>
                    <h1 className="text-4xl font-black italic tracking-tighter uppercase text-slate-900">System Logs</h1>
                    <p className="text-[10px] font-black uppercase text-rose-500 tracking-widest mt-1">Live Infrastructure Audit</p>
                </div>
                <div className="relative w-72">
                    <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
                    <input
                        className="w-full p-4 pl-12 bg-white rounded-2xl font-bold text-xs shadow-sm outline-none border-2 border-transparent focus:border-indigo-500 transition-all"
                        placeholder="Search Company or Action..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
            </div>

            <div className="bg-white rounded-[40px] shadow-sm border border-slate-100 overflow-hidden">
                <table className="w-full text-left">
                    <thead className="bg-slate-900 text-[9px] font-black uppercase text-slate-400 tracking-[0.2em]">
                        <tr>
                            <th className="p-6">Timestamp</th>
                            <th className="p-6 text-white">Company</th>
                            <th className="p-6 text-white">User</th>
                            <th className="p-6 text-white">Action</th>
                            <th className="p-6 text-white">Details</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {filteredLogs.map((log) => (
                            <tr key={log.id} className="hover:bg-indigo-50/30 transition-all group">
                                <td className="p-6 whitespace-nowrap">
                                    <div className="flex items-center gap-3 text-slate-400">
                                        <Clock size={14} />
                                        <span className="text-[10px] font-black">{new Date(log.created_at).toLocaleString()}</span>
                                    </div>
                                </td>
                                <td className="p-6">
                                    <div className="flex items-center gap-2">
                                        <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
                                        <span className="font-black text-slate-900 text-xs uppercase italic">{log.company_name}</span>
                                    </div>
                                </td>
                                <td className="p-6">
                                    <span className="text-xs font-bold text-slate-500">{log.user_name}</span>
                                </td>
                                <td className="p-6">
                                    <span className={`px-3 py-1 rounded-lg text-[9px] font-black uppercase tracking-tighter ${log.action.includes('DELETE') ? 'bg-rose-100 text-rose-600' :
                                        log.action.includes('CREATE') ? 'bg-emerald-100 text-emerald-600' : 'bg-slate-100 text-slate-600'
                                        }`}>
                                        {log.action}
                                    </span>
                                </td>
                                <td className="p-6">
                                    <p className="text-[11px] font-medium text-slate-600 max-w-xs truncate group-hover:whitespace-normal transition-all">
                                        {log.details}
                                    </p>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ActivityMonitor;